import { Collana } from './Collana';
import { Catalogazione } from './Catalogazione';
import { Contributor } from './Contributor';
import { Argomento } from './Argomento';
import { Bisac } from './Bisac';
import { Cce } from './Cce';
import { Dewey } from './Dewey';
import { Editore } from './Editore';
import { Distributore } from './Distributore';
import { Onix } from './Onix';
import { ProductRelationship } from './ProductRelationship';
import { Lingua } from './Lingua';
import { ServizioStampa } from './ServizioStampa';
import { StatusLog } from './StatusLog';


export class Book {

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

  _id: string;
  idtitolo: string;
  ean13: string;
  dewey: Dewey;
  dewey_level1: Dewey;
  dewey_level2: Dewey;
  dewey_level3: Dewey;
  dewey_level4: Dewey;
  dewey_descrizione: string;
  numColoriStampa: number;
  tavoleGrafiche: string;

  numinconfezione: string;
  // confezione: Confezione;
  confezione: Onix;


  taxCodeCEC: string;
  exportCEC: boolean;
  exportableCEC: boolean;
  visibilitaPortaleCED: boolean;
  homeNovita: boolean;
  lockuser: string;
  lockdate: string;
  inevidenza: boolean;
  pompaindice: boolean;

  visibile: boolean;
  carrellabile: boolean;

  bisac: Bisac[] = [];

  cce: Cce[] = [];

  catalogazione: Catalogazione[] = [];

  servizioStampa: ServizioStampa[] = [];

  note: string;
  NumUltimaRistampaEDB: number;
  titolodetailEDB: string;
  titolodetailCEC: string;

  notecommento: string;

  edizione: Onix;
  numedizione: number = 1;
  numristampa: number;

  tipoProdotto: Onix;
  tipoProdottoDettaglio: Onix;
  stagionalita: Onix[] = [];
  lingue: Lingua[] = [];

  relatedProducts: ProductRelationship[] = [];


  catalogoRow: string;

  edigitaOnix: string;

  descrizione: string;

  dtpubblicazione: Date;
  dtultimaristampa: Date;
  dtfuoricatalogo: Date;

  collana: Collana;
  collanaEDBnum: number;
  collanaEDBsezione: string;
  collanaEDBnumsezione: number;

  argomenti: Argomento[] = []; //argomenti RL (li chiamo 'argomenti' e uso solo questi)
  // {"onix3.DescriptiveDetail.Subject": { "$elemMatch":  {"SubjectSchemeIdentifier" : "24" } } }
  // NON USATI in komodo_ced
  argomentiCED: Argomento[] = [];

  // {"onix3.DescriptiveDetail.Audience": { "$elemMatch":  {"AudienceCodeType" : "02" } } }
  destinatari: Onix[] = [];

  prezzo: number;
  tax: Onix;

  statoeditore: Onix;
  statodistributore: Onix;

  altezza: number;
  larghezza: number;
  spessore: number;
  formato: string;
  peso: number;

  pagnumaraba: number;
  pagnumromana: number;
  pagcomplessive: number;
  pagindici: number;


  tipoContenuto1: Onix;
  tipoContenuto2: Onix;
  protezione: Onix;
  distributoreDigitale: Distributore;
  filesize: number;

  editore: Editore;
  marchio: Editore;
  coeditore: Editore;
  contributor: Contributor[] = [];
  cityOfPublication: string;
  autoriabbreviato: string;
  autoriabbreviatoedb: string;
  autoriportale: string;

  websiteLink: string;

  prefisso: string;
  titolo: string;
  sottotitolo: string;
  sottotitolo2: string;
  insiemetitolo: string;
  insiemeparte: string;
  sottoinsiemetitolo: string;
  sottoinsiemeparte: string;
  titolobreve: string;
  titolooriginale: string;
  titoloEDB: string; //aka tiolo catalogo

  conferenceName: string;
  conferenceSponsorName: string;
  conferenceNumber: number;
  conferenceDate: Date;
  // conferenceDateAl: Date; NON C'E' NELL'ONIX !!!
  conferencePlace: string;

  updatedDate: Date;
  exportedCEC: Date;

  statusLog: StatusLog[] = [];
}



// WEBPACK FOOTER //
// ./src/app/models/Book.ts